<template>
    <div>
        <!-- 动态 -->
        <div v-if="Object.keys(dynamicData).length > 0" class="content">
            <!-- 日期 -->
            <div class="tm">
                <div class="rq"> {{ handleDay(dynamicData.createTime) }} </div>
                <div class="ny">{{ handleYear(dynamicData.createTime) }}. {{ handleMonth(dynamicData.createTime) }}</div>
            </div>
            <!-- 纵向分割线 -->
            <div class="fg">
                <div class="round"></div>
            </div>

            <div class="nr">
                <div class="text">{{ dynamicData.content }}</div>

                <div class="content-type">
                    <video-view v-if="dynamicData.dynamicType == 1" :cover="dynamicData.cover"
                        :videoWidth="dynamicData.resourceWidth" :videoHeight="dynamicData.resourceHigh"
                        :videoUrl="dynamicData.attachFile"></video-view>

                    <image-view v-if="dynamicData.dynamicType == 0"
                        :images="handleImg(dynamicData.attachFile)"></image-view>
                </div>

                <div class="location">
                    来自 {{ dynamicData.location }}
                </div>

                <div class="footer">

                    <div class="label">
                        <div style="display:inline-block"> <img style="margin-right:3px" width="14" src="/imgs/htbg.png" />
                        </div>
                        <span class="text-sp">{{ dynamicData.talkName }}</span>
                    </div>

                    <div class="like">
                        <div class="in-line">
                            <img class="in-line" width="15" src="/imgs/pl.png" alt="">
                            <span style="margin-left:5px;color:#7D7D7D">{{ dynamicData.commentNum }}</span>
                        </div>

                        <div class="in-line" style="margin-left:29px">
                            <img class="in-line" width="15" src="/imgs/like.png" alt="">
                            <span style="margin-left:5px;color:#7D7D7D">{{ dynamicData.likeNum }}</span>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <div v-else class="zwdt">
            <img width="160" style="display: inline-block;margin-top: 40px;" src="/imgs/zwdt.png" />
            <br>
            <span class="dt-text">暂无动态</span>
        </div>
    </div>
</template>

<script>
import ImageView from './imageView.vue'
import videoView from "./videoView.vue"

export default {
    components: { videoView, ImageView },
    name: 'dynamic',
    props: {
        dynamicData: {
            type: Object,
            default: {}
        }
    },
    methods: {
        handleImg(value) {
            if (!value) return [];
            const data = value.split(',')
            return data;
        },
        handleYear(value) {
            if (!value) return '';
            const date = new Date(value)
            const y = date.getFullYear()
            return y
        },
        handleMonth(value) {
            if (!value) return '';
            const date = new Date(value)
            let MM = date.getMonth() + 1 // 月
            MM = MM < 10 ? ('0' + MM) : MM
            return MM
        },
        handleDay(value) {
            if (!value) return '';
            const date = new Date(value)
            let d = date.getDate() // 日
            d = d < 10 ? ('0' + d) : d
            return d
        }
    },

}
</script>

<style lang="less" scoped>
.in-line {
    display: inline-block;
}

.content {
    display: flex;
    background: #F8F8F8;

    .tm {
        margin-left: 14px;
        margin-top: 10px;

        .rq {
            font-size: 18px;
            font-weight: bold;
            color: #373737;
        }

        .ny {
            font-size: 9px;
            color: #666666;
            margin-top: 2px;
        }
    }

    .fg {
        background: #C6C6C6;
        height: 400px;
        width: 1px;
        margin-top: 20px;
        margin-left: 8px;

        .round {
            width: 5.5px;
            height: 5.5px;
            border-radius: 50px;
            background: #C6C6C6;
            position: relative;
            top: -2px;
            left: -2px;
        }
    }

    .nr {
        margin-top: 34.5px;
        margin-left: 12.5px;
        width: 268px;

        .text {
            font-size: 15px;
            font-weight: bold;
            overflow-wrap: anywhere;
            line-height: 22px
        }

        .content-type {
            margin-top: 10px;
        }

        .location {
            font-size: 11px;
            color: #373737;
            margin-top: 8px;

        }

        .footer {
            margin-top: 10px;
            display: flex;
            margin-bottom: 35px;

            .label {
                width: auto;
                border-radius: 10px;
                background: #CFCFCF;
                height: 21px;
                padding: 4px 10px 4px 10px;
                font-size: 9px;
                color: #292929;
                font-weight: 400;

                .text-sp {
                    position: relative;
                    top: -3px;
                    font-size: 9px;
                }
            }

            .like {
                flex: 1;
                text-align: right;
            }
        }
    }
}

.zwdt {
    text-align: center;
    height: 300px;
    background: #f8f8f8;
    .dt-text {
        font-size: 15px;
        font-weight: bold;
    }
}
</style>